import { getVariantValue } from "./variantTunnel";

export const checkWafResponse = async (url: string): Promise<number> => {
  try {
    const xBackendVariant = getVariantValue();
    const response = await fetch(url, {
      method: "HEAD",
      headers: {
        ...(xBackendVariant && { "X-Backend-Variant": xBackendVariant }),
      },
    });
    return response.status;
  } catch (error) {
    console.error("Error:", error);
    return 500;
  }
};
